import React from 'react';
import { cn } from '../../lib/utils';

const badgeVariants = {
  new: "bg-brand-cobalt text-white",
  exclusive: "bg-brand-petroleum text-white",
  bestseller: "bg-brand-petroleum text-white",
  sale: "bg-red-600 text-white",
  limited: "bg-brand-grape text-white",
  soldout: "bg-gray-600 text-white",
};

export const Badge = ({ variant = "new", className, children, ...props }) => {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center px-2 py-0.5 text-[10px] font-sans uppercase tracking-wider",
        badgeVariants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};

Badge.displayName = "Badge";
